/**
 * 调拨出库权限相关字段，来自
 * https://liaofeng.feishu.cn/sheets/shtcnZwEnu3NxrS22N9Onqwtuzb?sheet=a1f812
 */

/**
 * 调拨出库
 */
export const Read = 'wms_allocate_and_transfer_delivery_handle';
